import type { ReactNode } from "react";
import { View, Text } from "@src/components";
import { useUnistyles } from "react-native-unistyles";

interface ReportsSectionProps {
  /** Section title displayed above the items */
  title: string;
  /** A line under the title, such as what the section is about */
  subtitle?: string;
  /** List items to render inside the section */
  children: ReactNode;
}

export function ReportsSection({ title, subtitle, children }: ReportsSectionProps) {
  const { theme } = useUnistyles();

  return (
    <View
      bg="surfaceCardInner"
      borderWidth={1}
      borderColor="borderCard"
      borderRadius={theme.spacing.xl}
      p="5xl"
      gap="3xl"
    >
      <View gap="xs">
        <Text textStyle="md/semibold" color="textMuted">
          {title}
        </Text>
        {subtitle !== undefined && (
          <Text textStyle="sm/regular" color="textMuted">
            {subtitle}
          </Text>
        )}
      </View>
      <View gap="md">{children}</View>
    </View>
  );
}
